import Vue from 'vue'
import Vuetify from 'vuetify'
import { store } from '@/store/store'

Vue.use(Vuetify)

const darkThemeEnabled = localStorage.getItem('theme') === 'dark'

export default new Vuetify({
  theme: {
    dark: darkThemeEnabled,
    themes: store.getters.theme
  },
  icons: {
    iconfont: 'mdi',
  },
})
